import React from 'react';
import PropTypes from 'prop-types';

import {
    makeStyles
} from '@material-ui/core';

const propTypes = {
    children: PropTypes.node
};

const defaultProps = {
    children: null
};

const useStyles = makeStyles((theme) => styles(theme));

function AuthBodyActions ({ children }) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            { children }
        </div>            
    );
}

const styles = (theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        columnGap: '28px',
        '& > p:last-child': {
            marginLeft: 'auto'
        }
    }
});

AuthBodyActions.propTypes = propTypes;
AuthBodyActions.defaultProps = defaultProps;

export default AuthBodyActions;